import React from 'react';
import type { Dialog } from '@reach/dialog';
import { Localizer } from 'services/Localizer';
import XSVG from 'shared/components/svg/XSVG';
import Spinner from 'shared/components/Spinner';
const LazyDialog = React.lazy<typeof Dialog>(() =>
	import('@reach/dialog').then((module) => ({ default: module.Dialog })),
);

interface ModalProps {
	isOpen: boolean;
	closeModal: () => void;
	children?: React.ReactNode;
}

export default function ProductImageModal(props: ModalProps) {
	const { isOpen, closeModal, children } = props;

	return (
		<React.Suspense fallback={<Spinner />}>
			<LazyDialog
				isOpen={isOpen}
				className="roc-image-modal"
				onDismiss={() => closeModal()}
				aria-label={Localizer('ProductImageModal')}
				as={'div'}
			>
				<div className="roc-modal__header">
					<div className="roc-modal__title-container" />

					<div className="roc-modal__close">
						<button className="roc-modal__close-btn" onClick={() => closeModal()} type="button">
							<span className="roc-modal__close-text">{Localizer('Close')}</span>
							<span className="roc-modal__close-icon">
								<XSVG />
							</span>
						</button>
					</div>
				</div>

				<div>{children}</div>
			</LazyDialog>
		</React.Suspense>
	);
}
